module.exports = __webpack_public_path__ + "static/img/7.a78d7b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/7.png
// module id = 2OEo
// module chunks = 0